import React, { Component } from 'react';

class AdSenseArticle extends Component {
    componentDidMount() {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }


    render() {
        return (
            <div>
                <span>&nbsp;Ad</span>
                <ins className='adsbygoogle'
                    style={{
                        display:'block',textAlign:'center'}}
                    data-ad-layout="in-article"
                    data-ad-format="fluid"
                    data-ad-client="ca-pub-1551799716386587"
                    data-ad-slot="1879815896"></ins>
            </div>
        );
    }
}

export default AdSenseArticle;


// WEBPACK FOOTER //
// ./src/componentes/AdSenseArticle.js